import { loadStripe } from "@stripe/stripe-js";
import { api } from "@/lib/http";

// Stripe.js scoped to the clinic's own connected account (cards + charges land in THEIR Stripe, not the platform's).
export const loadClinicStripe = async () => {
  const { data } = await api.get("/payments/config");
  if (!data.publishable_key) return null;
  return loadStripe(data.publishable_key, data.stripe_account ? { stripeAccount: data.stripe_account } : undefined);
};
